export default "__VITE_ASSET__WjmDQXDH__"